import clsx from 'clsx';
import React, { Children } from 'react';
import Button from '~/components/Button';
import { Link, type LinksFunction, type V2_MetaFunction } from '~/remix';
import VideoJs from './VideoJs';

export let meta: V2_MetaFunction = () => [
  { title: 'Sunset Messages - Features' },
];

export let links: LinksFunction = () => [
  {
    rel: 'stylesheet',
    href: 'https://cdnjs.cloudflare.com/ajax/libs/video.js/7.10.2/video-js.min.css',
  },
];

export default function Landing() {
  return (
    <div className="mx-4 my-2 md:mx-24 md:my-4">
      <div className="flex flex-col gap-16">
        <InfoCard>
          <InfoCard.Text>
            <h2 className="text-center text-2xl font-bold  text-ssm-purple md:text-left">
              Add recipients
            </h2>
            <p className="mt-2 md:text-lg">
              Create or select your recipients. Once you have added a recipient
              they will appear in your recipients list. If you're not sure who
              to send a message to, you can{' '}
              <Link to="/recipients-help" className="underline">
                “Click here for brainstorming ideas”
              </Link>{' '}
              to help you pick the right people.
            </p>
          </InfoCard.Text>
          <InfoCard.Image>
            <VideoJs
              options={{
                autoplay: true,
                muted: true,
                loop: true,
                controls: false,
                fluid: true,
                sources: [
                  {
                    src: 'https://customer-pfsb5henr5ytsb93.cloudflarestream.com/26dde29f6c993ec71696f4e8620aa3bd/manifest/video.m3u8',
                    type: 'application/x-mpegURL',
                  },
                ],
              }}
            />
          </InfoCard.Image>
        </InfoCard>

        <InfoCard reverse>
          <InfoCard.Text>
            <h2 className="text-center text-2xl font-bold text-ssm-purple md:text-left">
              Write your heartfelt message
            </h2>
            <p className="mt-2 md:text-lg">
              Start with a familiarity phrase, so your recipient will easily
              recognize the message is from you. Once you have entered your
              Familiarity Phrase the next step is to fill in your message.
              Remember you can always go back and edit the message at any time
              after you have paid for it.
            </p>
          </InfoCard.Text>
          <InfoCard.Image>
            <VideoJs
              options={{
                autoplay: true,
                muted: true,
                loop: true,
                controls: false,
                fluid: true,
                sources: [
                  {
                    src: 'https://customer-pfsb5henr5ytsb93.cloudflarestream.com/3b72bd3219ad957c5d46252c9103f0d8/manifest/video.m3u8',
                    type: 'application/x-mpegURL',
                  },
                ],
              }}
            />
          </InfoCard.Image>
        </InfoCard>
        <InfoCard>
          <InfoCard.Text>
            <h2 className="text-center text-2xl font-bold text-ssm-purple md:text-left">
              Share treasured photo memories
            </h2>
            <p className="mt-2 md:text-lg">
              You can upload multiple photos to share with your loved ones. Take
              a photo with your device or drag-and-drop photos from your
              computer.
            </p>
          </InfoCard.Text>
          <InfoCard.Image>
            <VideoJs
              options={{
                autoplay: true,
                muted: true,
                loop: true,
                controls: false,
                fluid: true,
                sources: [
                  {
                    src: 'https://customer-pfsb5henr5ytsb93.cloudflarestream.com/db3f94aab2ed4bd456cc86825affa032/manifest/video.m3u8',
                    type: 'application/x-mpegURL',
                  },
                ],
              }}
            />
          </InfoCard.Image>
        </InfoCard>

        <InfoCard reverse>
          <InfoCard.Text>
            <h2 className="text-center text-2xl font-bold text-ssm-purple md:text-left">
              Give the gift of your voice with an Audio recording
            </h2>
            <p className="mt-2 md:text-lg">
              Many people keep voicemails left by their loved ones who have
              passed. This feature lets you be intentional about such a message
              that they can cherish forever.
            </p>
          </InfoCard.Text>
          <InfoCard.Image>
            <VideoJs
              options={{
                autoplay: true,
                muted: true,
                loop: true,
                controls: false,
                fluid: true,
                sources: [
                  {
                    src: 'https://customer-pfsb5henr5ytsb93.cloudflarestream.com/656120f011bbbae202644b2250987f21/manifest/video.m3u8',
                    type: 'application/x-mpegURL',
                  },
                ],
              }}
            />
          </InfoCard.Image>
        </InfoCard>

        <InfoCard>
          <InfoCard.Text>
            <h2 className="text-center text-2xl font-bold text-ssm-purple md:text-left">
              Record a Video message
            </h2>
            <p className="mt-2 md:text-lg">
              Take your message to the next level by sharing your likeness and
              voice in a personal video. You can use your phone or web cam to
              record a video message. Drag and drop options are also available
              if you have a prerecorded video you’d like to upload.
            </p>
          </InfoCard.Text>
          <InfoCard.Image>
            <img
              className="max-h-96"
              src="https://imagedelivery.net/u-2jVOQ91N--iZ9jR2vcqA/710d752d-713c-4abe-4a3c-29ac34305d00/public"
              alt="Record a video"
            />
          </InfoCard.Image>
        </InfoCard>

        <InfoCard reverse>
          <InfoCard.Text>
            <h2 className="text-center text-2xl font-bold text-ssm-purple md:text-left">
              How will you know when I have passed?
            </h2>
            This will be the responsibility of your Delivery Delegate(s). Your
            Delivery Delegate(s) will be someone you choose. Typically they will
            be a trusted family member or friend or they can also be the
            executor or trustee of your estate. They will notify us of your
            passing and upload a copy of your death certificate. After this is
            done, we will release your messages in accordance with your wishes.{' '}
          </InfoCard.Text>
          <InfoCard.Image>
            <img
              className="mx-auto block max-h-96"
              alt="Delivery Delegate"
              src="https://pub-d0d3ee311a224d32ab8898b10eb2c080.r2.dev/Screenshot%202023-08-03%20at%207.10.43%20PM.png"
            />
          </InfoCard.Image>
        </InfoCard>
      </div>
      <div className="mt-8">
        <div className="flex justify-center">
          <Button
            type="link"
            to="/app/messages/vault"
            size="lg"
            variant="primary"
          >
            Create a Message
          </Button>
        </div>
      </div>
    </div>
  );
}

type InfoCardProps = {
  reverse?: boolean;
  children: React.ReactNode;
};
function InfoCard({ children, reverse }: InfoCardProps) {
  return (
    <div
      className={clsx(
        'mt-4 flex flex-col items-center gap-8',
        reverse ? 'md:flex-row-reverse' : 'md:flex-row',
      )}
    >
      <div className="flex-1">{render(children, InfoCardText)}</div>
      <div className="w-full sm:flex-1">{render(children, InfoCardImage)}</div>
    </div>
  );
}

function render(children: React.ReactNode, component: any) {
  const arrayChildren = Children.toArray(children);
  return Children.map(arrayChildren, (child) =>
    // @ts-ignore
    child.type === component ? <>{child}</> : null,
  );
}

function InfoCardText({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
function InfoCardImage({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

InfoCard.Text = InfoCardText;
InfoCard.Image = InfoCardImage;
